import { Component } from '@angular/core';
import { Options } from 'angular2-notifications';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {

    //#region properties

    title = 'app';

    public notificationOptions: Options = {
        timeOut: 1500, //ms
        pauseOnHover: false,
        showProgressBar: false,
        animate: 'fromBottom'
    };

    //#enregion

}
